import { Button } from '@mui/material';
import { Chain } from '@ankr.com/chains-list';

import { useTranslation } from 'modules/i18n/hooks/useTranslation';
import { useAddNetwork } from 'modules/wallet/hooks/useAddNetwork';
import { useNetworkConfig } from 'modules/wallet/hooks/useNetworkConfig';

import { addToWalletButtonTranslation } from './translation';

interface AddToWalletButtonProps {
  chain: Chain;
}

export const AddToWalletButton = ({ chain }: AddToWalletButtonProps) => {
  const { keys, t } = useTranslation(addToWalletButtonTranslation);

  const { handleAddNetwork } = useAddNetwork();

  const networkConfig = useNetworkConfig({ chain });

  return (
    <Button
      disabled={!networkConfig}
      onClick={() => handleAddNetwork(networkConfig!)}
      size="large"
      fullWidth
    >
      {t(keys.addToWallet)}
    </Button>
  );
};
